import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Cell, Row } from '@calendly/ui/components/table'
import { BodyText } from '@calendly/ui/components/typography'
import { CheckboxField } from '@calendly/ui/form/checkbox-field'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useDispatch, useSelector } from 'react-redux'

import { MembershipInfo } from 'features/user_info'
import { selectAllStatusSelector, toggleSelection, toggleExcludedId } from 'features/users_page'

import { invitationToMembership } from '../helpers'

export const PendingUser = ({ invitation }) => {
  const dispatch = useDispatch()
  const selectAllStatus = useSelector(selectAllStatusSelector)

  const isPhone = useDeviceType('isPhone')
  const inviteLastSent = I18n.t('publisher.admin.dashboard.section.users.modal.pending_users.invite_last_sent')

  const date = invitation.brief_last_sent_at || invitation.brief_created_at

  const toggleInvitation = () => {
    if (selectAllStatus) dispatch(toggleExcludedId(invitation))
    dispatch(toggleSelection(invitation))
  }

  return (
    <Row>
      <Cell>
        <CheckboxField
          checked={invitation.is_selected}
          onChange={toggleInvitation}
          aria-label={I18n.t('publisher.components.table.select_item', { item: invitation.email })}
        />
      </Cell>
      {
        isPhone ? (
          <Cell>
            <BodyText>{invitation.email}</BodyText>
            <BodyText size="medium" color="muted">
              {`${inviteLastSent}: ${date}`}
            </BodyText>
          </Cell>
        ) : (
          <>
            <Cell>
              <MembershipInfo membership={invitationToMembership(invitation)} isAvatarNonInteractive />
            </Cell>
            <Cell noWrap>
              <BodyText size="medium" color="muted">
                {HtmlParser(`${inviteLastSent}: <br/> ${date}`)}
              </BodyText>
            </Cell>
          </>
        )
      }
    </Row>
  )
}
